import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import PrivacyPolicy from "./page/PrivacyPolicy";
import Footer from "./components/Footer";
import TermsOfUse from "./page/TermsOfUse";
import AboutUs from "./page/AboutUs";
import ScrollToTop from "./components/ScrollToTop";
import History from "./page/History";
import HistoryData from "./page/HistoryData";
import Disclaimer from "./page/Disclaimer";
import CookieConsent from "./components/CookieConsent";
import MainCards from "./components/MainCards";
import './i18n';
import FdCalc from "./calculater/FdCalc";
import SipAndSwp from "./components/SipAndSwp";
import PersonalLoanCalc from "./calculater/PersonalLoanCalc";
import RdCalc from "./calculater/RdCalc";
import DtiCalc from "./calculater/DtiCalc";
import NetWorthcalc from "./calculater/NetWorthCalc";
import EarlyLoanCalc from "./calculater/EarlyLoanCalc";
import EducationCalc from "./calculater/EducationCalc";
import CreditCalc from "./calculater/CreditCalc";
import BussinessCalc from "./calculater/BussinessCalc";
import GstCalc from "./calculater/GstCalc";
import SalaryCalc from "./calculater/SalaryCalc";
import PensionCalc from "./calculater/PensionCalc";
import CarCalc from "./calculater/CarCalc";
import MortgageCalc from "./calculater/MortgageCalc";
import ContributionCalc from "./calculater/ContributionCalc";
import SavingCalc from "./calculater/SavingCalc";
import LtvCalc from "./calculater/LtvCalc";
import Gstboard from "./calculater/Gstboard";
import SIPBoard from "./components/SIPBoard";
import LandingPage from "./page/LandingPage";
function Layout() {
  return (
    <>
      <main>
        <ScrollToTop />
        <Outlet />
        <CookieConsent />
      </main>
      <Footer />
    </>
  );
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App/>
      {/* <RouterProvider router={router} /> */}
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
